import BriefView from "../../brief/BriefView";
import LightPageLayout from "../../components/Page/LightPageLayout";
import PageHeader from "../../components/Page/PageHeader";
import Spacer from "../../components/space/Spacer";
import Text from "../../components/Text";
import { useOutgoingRequest } from "../../data/tanstack-query";
import { getEmail } from "../../endpoints/outgoing-requests";
import { EmailStatusInfo } from "../../enums/EmailStatus";
import { usePathParams } from "../../navigation/hooks";
import { mailRoute } from "./navigation";

export default function MailPage() {
    const { email: id } = usePathParams(mailRoute);
    const email = useOutgoingRequest(getEmail(id));
    return (
        <LightPageLayout>
            <PageHeader title={email.subject} />
            <Text variant="body">
                {email.recipientName} · {email.recipientEmail}
            </Text>
            <Text variant="minor">
                {EmailStatusInfo[email.status].label} · {formatDate(email.statusAt)}
            </Text>
            <Spacer scale={4} />
            <BriefView blocks={email.brief} />
        </LightPageLayout>
    );
}

function formatDate(value: string) {
    return new Date(value).toLocaleString("fr-FR");
}
